import React, { useContext } from 'react';

import cx from 'classnames';
import { is } from 'ramda';

import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import Table from 'components/shared/Table';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import i18n from 'i18n';
import { LANDING_THEMES } from 'utils/itineraries/functions';
import { isNotDefined } from 'utils/ramda';

import styles from '../index.module.css';
import { useManifestTable } from './functions';
import s from './style.module.css';

function ManifestTable() {
  const { goToItinerary, itineraryDetails } = useManifestTable();
  const { isTabletOrMobile } = useMediaBreakpoints();
  const { landingTheme } = useContext(LandingPageContext);

  const columns = [
    {
      Header: i18n.t('proposal_content.trip_manifest.tabs.date'),
      accessor: 'date',
      fixedSize: landingTheme === LANDING_THEMES.jbd ? '140px' : '70px',
      className: cx(styles.thDate, styles.thNomadDate, 'custom-manifest-thDate'),
      Cell: ({ value: data }) => {
        if (!data?.formattedRange) {
          return <span className="tdEmpty">–</span>;
        }

        return (
          <div>
            <span>{data.formattedRange}</span>
            {data.formattedNumberOfNights && (
              <div className={cx(styles.numOfNights, 'custom-manifest-numOfNights')}>
                {data.formattedNumberOfNights}
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: i18n.t('proposal_content.trip_manifest.tabs.activities'),
      accessor: 'details',
      className: cx(styles.thDetails, styles.thNomadDetails, 'custom-manifest-thDetails'),
    },
    {
      Header: i18n.t('proposal_content.trip_manifest.tabs.accommodations'),
      accessor: 'rooming',
      fixedSize: isTabletOrMobile ? '188px' : landingTheme === LANDING_THEMES.jbd ? '190px' : '140px',
      className: cx(styles.thAcc, styles.thNomadAcc, 'custom-manifest-thAcc'),
      Cell: ({ value }) => {
        if (isNotDefined(value)) return null;
        if (!is(String, value)) return null;

        return <div className={s.textOverflow}>{value}</div>;
      },
    },
  ];

  return (
    <Table
      theadClassName={cx(styles.thead, 'custom-manifest-thead')}
      tableClassName={cx(styles.table, 'custom-manifest-table')}
      columns={columns}
      data={itineraryDetails}
      onClick={goToItinerary}
      withFixSizedColumns
    />
  );
}

export default ManifestTable;
